import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import { installChunkRecovery } from './chunkRecovery'
import { i18n } from './i18n'
import { installErrorReporting } from './observability'
import { router } from './router'
import './styles/main.css'

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
installErrorReporting(app, router)
installChunkRecovery(router)

app.use(router)

// The router's first navigation re-validates the stored token, so mounting
// after it settles means no page ever flashes before the guard decides.
void router.isReady().then(() => app.mount('#app'))
